import { sendGTMEvent } from '@next/third-parties/google';

import { OffsetKey } from '@/types/models/solarEcomm/products';

interface EventItem {
  [index: string]: string | number | string[] | number[] | undefined;
}

export interface Event {
  event: string;
  [index: string]:
    | string
    | number
    | string[]
    | number[]
    | boolean
    // required for maps
    | (number | undefined)[]
    | EventItem
    | Array<EventItem>
    | undefined
    | null;
}

export const trackEvents = (rawData: Array<Event> | Event): void => {
  const events = Array.isArray(rawData) ? rawData : [rawData];
  events.forEach((event) => {
    sendGTMEvent(event);
  });
};

type AnalyticsItem = {
  item_id: string;
  item_name: string;
};

const solarCoverageAnalyticsMapping: {
  [value in OffsetKey]: AnalyticsItem;
} = {
  [OffsetKey.SMALL_OFFSET]: {
    item_id: 'essential_coverage',
    item_name: 'Essential Coverage',
  },
  [OffsetKey.LARGE_OFFSET]: {
    item_id: 'extended_coverage',
    item_name: 'Extended Coverage',
  },
};

export const handleCoverageNaming = (offsetKey: OffsetKey): AnalyticsItem => {
  return solarCoverageAnalyticsMapping[offsetKey];
};

const batteryAnalyticsMapping: AnalyticsItem[] = [
  {
    item_id: 'no_battery',
    item_name: 'No Battery',
  },
  {
    item_id: 'essential_home_backup',
    item_name: 'Essential Backup',
  },
  {
    item_id: 'extended_home_backup',
    item_name: 'Extended Backup',
  },
  {
    item_id: 'extended_plus_backup',
    item_name: 'Extended Plus Backup',
  },
];

export const handleStorageNaming = (
  storageSizeIndex: number
): AnalyticsItem => {
  return batteryAnalyticsMapping[storageSizeIndex];
};

// customize page has no "no battery" option, so we just start one higher in the index
export const handleCustomizeStorageNaming = (
  storageSizeIndex: number
): AnalyticsItem => {
  return batteryAnalyticsMapping[storageSizeIndex + 1];
};
